import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL ? `${process.env.REACT_APP_BACKEND_URL}/api/staff` : "";

export const staffApi = axios.create({ baseURL: BASE, withCredentials: true });

export const errMsg = async (err, fallback = "Something went wrong. Please try again.") => {
  let detail = err?.response?.data?.detail;
  const blob = err?.response?.data;
  if (!detail && blob && typeof blob.text === "function") {
    try { detail = JSON.parse(await blob.text())?.detail; } catch { detail = null; }
  }
  if (!detail) return err?.response ? fallback : "Could not reach the server. Check your connection and try again.";
  if (typeof detail === "string") return detail;
  if (typeof detail?.message === "string") return detail.message;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg).filter(Boolean).join(" ") || fallback;
  return fallback;
};

export const fmtDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso.endsWith("Z") || iso.includes("+") ? iso : `${iso}Z`);
  return d.toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" });
};

export const saveBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};
